// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__6Dwbu","questions":"styles_questions__27b-z","footer":"styles_footer__18Kzp"};